import { handleActions } from 'redux-actions';
import update from 'immutability-helper';

import {
	GET_PERSONAL_PAYROLL_LIST_CALL,
	GET_PERSONAL_PAYROLL_LIST_DONE,
	GET_PERSONAL_PAYROLL_LIST_FAIL,
	GET_PERSONAL_PAYROLL_DETAIL_CALL,
	GET_PERSONAL_PAYROLL_DETAIL_DONE,
	GET_PERSONAL_PAYROLL_DETAIL_FAIL,
	GET_PAYSLIP_DISPLAY_SETTINGS_CALL,
	GET_PAYSLIP_DISPLAY_SETTINGS_DONE,
	GET_PAYSLIP_DISPLAY_SETTINGS_FAIL,
	GET_PAYROLL_TASK_DISPLAY_SETTINGS_CALL,
	GET_PAYROLL_TASK_DISPLAY_SETTINGS_DONE,
	GET_PAYROLL_TASK_DISPLAY_SETTINGS_FAIL,
} from '@src/store/types';

const defaultSideEffectState = {
	isLoading: false,
	isLoaded: false,
	error: null,
};

const initialState = {
	personalPayrollList: [],
	getPersonalPayrollListSideEffect: defaultSideEffectState,
	personalPayrollDetail: {},
	getPersonalPayrollDetailSideEffect: defaultSideEffectState,
	payslipDisplaySettings: {},
	getPayslipDisplaySettingsSideEffect: defaultSideEffectState,
	payrollTaskDisplaySettings: {},
	getPayrollTaskDisplaySettingsSideEffect: defaultSideEffectState,
};

export default handleActions({
	[GET_PERSONAL_PAYROLL_LIST_CALL](state) {
		return update(state, {
			getPersonalPayrollListSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PERSONAL_PAYROLL_LIST_DONE](state, { payload: { res } }) {
		return update(state, {
			personalPayrollList: { $set: res },
			getPersonalPayrollListSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PERSONAL_PAYROLL_LIST_FAIL](state, { payload }) {
		return update(state, {
			getPersonalPayrollListSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_PERSONAL_PAYROLL_DETAIL_CALL](state) {
		return update(state, {
			getPersonalPayrollDetailSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PERSONAL_PAYROLL_DETAIL_DONE](state, { payload: { res } }) {
		return update(state, {
			personalPayrollDetail: { $set: res },
			getPersonalPayrollDetailSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PERSONAL_PAYROLL_DETAIL_FAIL](state, { payload }) {
		return update(state, {
			getPersonalPayrollDetailSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_PAYSLIP_DISPLAY_SETTINGS_CALL](state) {
		return update(state, {
			getPayslipDisplaySettingsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PAYSLIP_DISPLAY_SETTINGS_DONE](state, { payload: { res } }) {
		return update(state, {
			payslipDisplaySettings: { $set: res },
			getPayslipDisplaySettingsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PAYSLIP_DISPLAY_SETTINGS_FAIL](state, { payload }) {
		return update(state, {
			getPayslipDisplaySettingsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
	[GET_PAYROLL_TASK_DISPLAY_SETTINGS_CALL](state) {
		return update(state, {
			getPayrollTaskDisplaySettingsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoading: true,
			} },
		});
	},
	[GET_PAYROLL_TASK_DISPLAY_SETTINGS_DONE](state, { payload: { res } }) {
		return update(state, {
			payrollTaskDisplaySettings: { $set: res },
			getPayrollTaskDisplaySettingsSideEffect: { $set: {
				...defaultSideEffectState,
				isLoaded: true,
			} },
		});
	},
	[GET_PAYROLL_TASK_DISPLAY_SETTINGS_FAIL](state, { payload }) {
		return update(state, {
			getPayrollTaskDisplaySettingsSideEffect: { $set: {
				...defaultSideEffectState,
				error: payload.error,
			} },
		});
	},
}, initialState);
